// jQuery is not used, because initializer can be used on multiple services (without jQuery)
// TODO remove this after complete migration to webpack:
// addEventListener("load", () => {
//     new LoadingBarsInitializer().init();
// });

export default class LoadingBarsInitializer {
    public init(): void {
        const loader = new lv();
        loader.initLoaderAll();
        loader.startObserving();
    }

    public reinit(): void { // workaround when initialization failed
        const loader = new lv();
        loader.initLoaderAll();
    }
}
